(function () {
  var BASE_URL = 'https://home.hitoyasumi.co';

  function buildProductUrl(url, attribution) {
    if (!url) return '';

    var isAbsolute = /^https?:\/\//.test(url);
    var parsed = new URL(url, BASE_URL);
    parsed.searchParams.set('hh_guide', '1');
    parsed.searchParams.set('hh_path', attribution.path);
    if (attribution.axis) parsed.searchParams.set('hh_axis', attribution.axis);
    if (attribution.choiceId) parsed.searchParams.set('hh_choice', attribution.choiceId);
    if (attribution.rank) parsed.searchParams.set('hh_rank', String(attribution.rank));

    return isAbsolute ? parsed.toString() : parsed.pathname + parsed.search + parsed.hash;
  }

  function routeHandles(route) {
    if (!route) return [];
    if (route.primary || route.secondary) {
      return [route.primary].concat(route.secondary || []);
    }
    return [
      route.primary_handle,
      route.secondary_handle_1,
      route.secondary_handle_2
    ];
  }

  function resolveRoute(route, products) {
    var seen = {};
    return routeHandles(route).reduce(function (resolved, handle) {
      var product = handle && products ? products[handle] : null;
      if (!product || !product.url || seen[handle]) return resolved;
      seen[handle] = true;
      resolved.push(product);
      return resolved;
    }, []);
  }

  function parseJson(root, selector, fallback) {
    var node = root.querySelector(selector);
    if (!node) return fallback;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.warn('[ChoiceGuide] JSON parse failed:', error);
      return fallback;
    }
  }

  function capture(root, eventName, properties, options) {
    try {
      if (!window.posthog || typeof window.posthog.capture !== 'function') return;
      var base = {
        entry_surface: root.dataset.entrySurface || null,
        section_id: root.dataset.sectionId || null,
        instrumentation_source: 'theme_choice_guide_cplus'
      };
      window.posthog.capture(
        eventName,
        Object.assign(base, properties || {}),
        options || {}
      );
    } catch (error) {
      console.warn('[ChoiceGuide] analytics capture failed:', error);
    }
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#039;');
  }

  function renderOptions(root, axis) {
    var options = root.querySelector('[data-choice-gift-options]');
    if (!options) return;
    var routes = (root.choiceGuideRoutes || []).filter(function (route) {
      return route.axis === axis;
    });
    options.innerHTML = routes.map(function (route) {
      return [
        '<button type="button" data-choice-gift-choice="' + escapeHtml(route.choice_id) + '"',
        ' data-choice-axis="' + escapeHtml(route.axis) + '">',
        '<span>' + escapeHtml(route.label) + '</span>',
        '<span>' + escapeHtml(route.supporting_text) + '</span>',
        '</button>'
      ].join('');
    }).join('');
  }

  function productCard(product, route, rank) {
    var url = buildProductUrl(product.url, {
      path: 'gift',
      axis: route.axis,
      choiceId: route.choice_id,
      rank: rank
    });
    var media = product.image
      ? '<img src="' + escapeHtml(product.image) + '" alt="' +
        escapeHtml(product.image_alt || product.title) +
        '" width="720" height="720" loading="lazy">'
      : '';
    var label = rank === 1 ? 'まずはこちら' : 'こちらもおすすめ';
    return [
      '<article class="c-choice-guide__result-card c-choice-guide__result-card--rank-' + rank + '">',
      '<div class="c-choice-guide__result-media">' + media + '</div>',
      '<div class="c-choice-guide__result-copy">',
      '<p class="c-choice-guide__result-rank">' + label + '</p>',
      '<h4>' + escapeHtml(product.title) + '</h4>',
      '<p>' + escapeHtml(product.gift_copy || '') + '</p>',
      '<p>' + escapeHtml(product.price || '') + '</p>',
      '<a href="' + escapeHtml(url) + '" data-choice-product-link',
      ' data-choice-path="gift"',
      ' data-choice-axis="' + escapeHtml(route.axis) + '"',
      ' data-choice-id="' + escapeHtml(route.choice_id) + '"',
      ' data-product-handle="' + escapeHtml(product.handle) + '"',
      ' data-recommendation-rank="' + rank + '">商品ページで見る</a>',
      '</div>',
      '</article>'
    ].join('');
  }

  function renderRoute(root, route) {
    var result = root.querySelector('[data-choice-gift-result]');
    if (!result) return;
    var products = resolveRoute(route, root.choiceGuideProducts);

    if (products.length === 0) {
      result.innerHTML = [
        '<div class="c-choice-guide__empty">',
        '<h3>商品一覧から香りを見る</h3>',
        '<p>現在表示できる候補がありません。商品一覧からお選びください。</p>',
        '<a href="#product-grid">商品一覧へ</a>',
        '</div>'
      ].join('');
    } else {
      result.innerHTML = [
        '<div class="c-choice-guide__result-head">',
        '<p>' + escapeHtml(route.label) + '</p>',
        '<h3>贈りたい気持ちに、合いそうな香り</h3>',
        '</div>',
        '<div class="c-choice-guide__result-grid">',
        products.map(function (product, index) {
          return productCard(product, route, index + 1);
        }).join(''),
        '</div>'
      ].join('');
    }
    result.focus();
  }

  function setPath(root, path) {
    var selfPanel = root.querySelector('[data-choice-self-panel]');
    var giftPanel = root.querySelector('[data-choice-gift-panel]');
    root.querySelectorAll('[data-choice-path-control]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(button.dataset.choicePath === path));
    });
    if (selfPanel) selfPanel.hidden = path !== 'self';
    if (giftPanel) giftPanel.hidden = path !== 'gift';

    if (path === 'self') {
      var quizStart = root.querySelector('[data-hquiz-start]');
      if (quizStart) quizStart.click();
    }
    if (path === 'gift') setAxis(root, 'recipient');
  }

  function setAxis(root, axis) {
    var result = root.querySelector('[data-choice-gift-result]');
    root.querySelectorAll('[data-choice-gift-axis]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.choiceGiftAxis === axis));
    });
    if (result) result.innerHTML = '';
    renderOptions(root, axis);
  }

  function observeComparison(root) {
    var comparison = root.querySelector('[data-choice-comparison]');
    if (!comparison || typeof IntersectionObserver !== 'function') return;
    var captured = false;
    var observer = new IntersectionObserver(function (entries) {
      var visible = entries.some(function (entry) {
        return entry.isIntersecting && entry.intersectionRatio >= 0.5;
      });
      if (!visible || captured) return;
      captured = true;
      capture(root, 'scent_comparison_view', {
        product_count: Object.keys(root.choiceGuideProducts || {}).length
      });
      observer.disconnect();
    }, { threshold: 0.5 });
    observer.observe(comparison);
  }

  function init(root) {
    if (!root || root.dataset.choiceGuideReady === 'true') return;
    root.dataset.choiceGuideReady = 'true';
    root.choiceGuideProducts = parseJson(root, '[data-choice-guide-products]', {});
    root.choiceGuideRoutes = parseJson(root, '[data-choice-guide-routes]', []);
    var giftPanel = root.querySelector('[data-choice-gift-panel]');
    if (giftPanel) giftPanel.hidden = true;
    observeComparison(root);
    root.addEventListener('click', function (event) {
      if (!event.target || typeof event.target.closest !== 'function') return;

      var pathButton = event.target.closest('[data-choice-path-control]');
      if (pathButton) {
        setPath(root, pathButton.dataset.choicePath);
        if (pathButton.dataset.choicePath === 'gift' && !root.choiceGuideGiftViewed) {
          root.choiceGuideGiftViewed = true;
          capture(root, 'gift_path_view');
        }
        return;
      }

      var axisButton = event.target.closest('[data-choice-gift-axis]');
      if (axisButton) {
        setAxis(root, axisButton.dataset.choiceGiftAxis);
        return;
      }

      var productLink = event.target.closest('[data-choice-product-link]');
      if (productLink) {
        var position = Number(productLink.dataset.recommendationRank);
        if (productLink.dataset.choicePath === 'gift') {
          capture(root, 'gift_path_product_click', {
            axis: productLink.dataset.choiceAxis || null,
            choice_id: productLink.dataset.choiceId || null,
            product_handle: productLink.dataset.productHandle || null,
            recommendation_rank: position
          }, { send_instantly: true });
        } else if (productLink.dataset.choicePath === 'compare') {
          capture(root, 'scent_compare_product_click', {
            product_handle: productLink.dataset.productHandle || null,
            position: position
          }, { send_instantly: true });
        }
        return;
      }

      var choiceButton = event.target.closest('[data-choice-gift-choice]');
      if (!choiceButton) return;
      var route = root.choiceGuideRoutes.find(function (candidate) {
        return candidate.axis === choiceButton.dataset.choiceAxis &&
          candidate.choice_id === choiceButton.dataset.choiceGiftChoice;
      });
      if (route) {
        renderRoute(root, route);
        capture(root, 'gift_path_choice', {
          axis: route.axis,
          choice_id: route.choice_id,
          choice_label: route.label
        });
      }
    });
  }

  function initAll() {
    document.querySelectorAll('[data-choice-guide]').forEach(init);
  }

  window.HitoyasumiChoiceGuide = {
    buildProductUrl: buildProductUrl,
    resolveRoute: resolveRoute,
    init: init
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
